import { docService } from '@/_services'

export default {
  methods: {
    $_uploadFile (file) {
      var formData = new FormData();
      formData.append("file", file)
      return docService.uploadRfiles(formData)
    }
  }
}